import { useEffect, useSyncExternalStore } from "react";
import { Navigate, Outlet } from "react-router-dom";

const SESSION_CHANGED = "simatomic-session-changed";
const sessionToken = () => localStorage.getItem("accessToken") || "";

// This is a UI expiry/format check. Only the API verifies the signature.
export function isCurrentSession(value) {
  try {
    const account = typeof value === "string" ? JSON.parse(value) : value;
    return Boolean(account?.user_id && typeof account.session_token === "string"
      && account.session_token.split(".").length === 3
      && Number.isFinite(account.expires_at) && account.expires_at * 1000 > Date.now());
  } catch { return false; }
}

function subscribeToSession(callback) {
  const events = ["storage", "focus", "pageshow", SESSION_CHANGED];
  events.forEach((event) => window.addEventListener(event, callback));
  return () => events.forEach((event) => window.removeEventListener(event, callback));
}

export function notifySessionChange() {
  window.dispatchEvent(new Event(SESSION_CHANGED));
}

export function clearPortalSession() {
  ["accessToken", "userRole", "userStatus", "demoTourActive", "demoTourStep"].forEach((key) => localStorage.removeItem(key));
  Object.keys(localStorage).filter((key) => key.startsWith("mdscaleway_")).forEach((key) => localStorage.removeItem(key));
  Object.keys(sessionStorage).filter((key) => key.startsWith("simatomicProject:")).forEach((key) => sessionStorage.removeItem(key));
  notifySessionChange();
}

export function RequirePortalSession() {
  const token = useSyncExternalStore(subscribeToSession, sessionToken, () => "");
  const valid = isCurrentSession(token);
  useEffect(() => {
    if (!valid) { if (token) clearPortalSession(); return undefined; }
    const expiresAt = JSON.parse(token).expires_at * 1000;
    const timer = setTimeout(clearPortalSession, Math.min(expiresAt - Date.now(), 2147483647));
    return () => clearTimeout(timer);
  }, [token, valid]);
  // Replacing the outlet also discards the previous account's page state when
  // another tab logs in with a different account.
  return valid ? <Outlet key={token} /> : <Navigate to="/login" replace />;
}
